import { render } from "./Build.vue?vue&type=template&id=9e5efe38"
import script from "./Build.vue?vue&type=script&lang=js"
export * from "./Build.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/house/Build.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e5efe38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e5efe38', __exports__)) {
    api.reload('9e5efe38', __exports__)
  }
  
  module.hot.accept("./Build.vue?vue&type=template&id=9e5efe38", () => {
    api.rerender('9e5efe38', render)
  })

}


export default __exports__